import { useAppContext } from 'contexts/AppContext';
import Routes from 'routes';
import { UserRole } from 'globals/types';
import { useRole } from './useRole';

export const useRouteGuards = (route: Routes): boolean => {
  const { isVerified, isUpgraded } = useAppContext();
  const isAccountant = useRole([UserRole.ADMIN, UserRole.ACCOUNTANT]);
  const isDeveloper = useRole([UserRole.ADMIN, UserRole.DEV]);
  const isLeader = useRole([UserRole.ADMIN, UserRole.LEADER]);

  switch (route) {
    case Routes.UPGRADE:
      return !!(isVerified && !isUpgraded && isAccountant);
    case Routes.BILLINGS:
      return !!(isVerified && isUpgraded && isAccountant);
    case Routes.DEVELOPERS:
      return !!(isVerified && isDeveloper);
    case Routes.LEADERBOARD:
      return !!(isVerified && isLeader);
    case Routes.SETTINGS:
      return !!(isVerified && isLeader);
    case Routes.ROOT:
      return !!isVerified;
    default:
      return false;
  }
};
